/* eslint-disable react/no-unused-state, object-shorthand */
import { PureComponent } from 'react'
import handleOnClickOutside from 'react-onclickoutside'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import Icon from '../Icon'
import InputField from '../InputField/InputField'
import InputFieldItem from './InputFieldItem'

const StyledIcon = styled(Icon)`
  display: flex !important;
  align-items: center !important;
`

const StyledItemList = styled.div`
  margin-top: 20px !important;
`

class inputFieldItems extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isHover: false,
      isFocus: false,
      items: this.props.items || [],
      value: '',
      errorText: this.props.errorText || '',
      hasError: false,
    }
    this.onFocus = this.onFocus.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onHover = this.onHover.bind(this)
    this.onHoverOut = this.onHoverOut.bind(this)
    this.onClick = this.onClick.bind(this)
    this.handleOnClickIcon = this.handleOnClickIcon.bind(this) || (() => {})
    this.onChange = this.onChange.bind(this)
  }

  onClick() {
    const { onClick } = this.props
    if (onClick) {
      onClick()
    }
  }

  onHover() {
    this.setState({
      isHover: true,
    })
  }

  onHoverOut() {
    this.setState({
      isHover: false,
    })
  }

  onFocus() {
    this.setState({
      isFocus: true,
    })
    const { onFocus } = this.props
    onFocus()
  }

  onSubmit() {
    this.setState({
      isFocus: false,
    })
    const { onValidate, errorText } = this.props
    const { value } = this.state

    if (onValidate) {
      const isValid = onValidate(this)

      if (isValid) {
        this.setState({
          errorText: '',
          hasError: false,
        })
        this.submitItem(value)
      } else {
        this.setState({
          errorText: errorText,
          hasError: true,
        })
      }
    } else {
      this.submitItem(value)
    }
  }

  onBlur() {
    this.setState({
      isFocus: false,
    })
    const { onBlur } = this.props
    onBlur()
  }

  onChange(event) {
    const { onChange } = this.props
    this.setState({
      value: event.target.value,
    })
    if (onChange) {
      onChange(event)
    }
  }

  handleClickOutside = e => {
    const { handleOnClickOutside } = this.props
    if (handleOnClickOutside) {
      handleOnClickOutside(e)
    }
  }

  onClickActionLink = () => {
    const { onClickActionLink } = this.props
    onClickActionLink()
  }

  handleOnClickIcon() {
    const { handleOnClickIcon, isClearable, handleOnClear } = this.props
    if (isClearable && handleOnClear) {
      handleOnClear()
      return
    }

    this.onSubmit()

    if (handleOnClickIcon) {
      handleOnClickIcon()
    }
  }

  submitItem(value) {
    if (!value || value.trim().length <= 0) {
      this.setState({
        value: '',
      })
      return
    }

    const { items } = this.state
    const { onSubmit } = this.props
    const newItems = [...items, { value: value }]

    this.setState(
      {
        isFocus: false,
        items: newItems,
        value: '',
      },
      () => {
        onSubmit(newItems)
      }
    )
  }

  onItemDelete = index => {
    const { items } = this.state
    const { onSubmit } = this.props
    const newItems = items.filter((_, x) => x !== index)

    this.setState(
      {
        items: newItems,
      },
      () => {
        onSubmit(items)
      }
    )
  }

  render() {
    const { disabled, disableDelete, onChange, onSubmit, onKeyPress, onValidate, handleOnClickIcon, classes, ...rest } =
      this.props
    const { items, errorText, hasError } = this.state

    return (
      <ThemeProvider theme={theme}>
        <InputField
          {...rest}
          errorText={errorText}
          hasError={hasError}
          onChange={onChange || this.onChange}
          onSubmit={this.onSubmit}
          handleOnClickIcon={handleOnClickIcon || this.handleOnClickIcon}
          onKeyPress={event => {
            if (event.key === 'Enter' && !disabled) {
              this.onSubmit()
            }

            if (onKeyPress) {
              onKeyPress(event)
            }
          }}
          value={this.state.value}
          disabled={disabled}
          icon={<StyledIcon iconName="plusCircle" iconSize={28} color={theme.colors.teal} />}
          childrenAfterInput={
            <StyledItemList>
              {items.map((item, index) => {
                return (
                  <InputFieldItem
                    // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                    key={index}
                    disableDelete={disableDelete}
                    classes
                    onDelete={() => {
                      if (!disableDelete) {
                        this.onItemDelete(index)
                      }
                    }}
                    {...item}
                  />
                )
              })}
            </StyledItemList>
          }
        />
      </ThemeProvider>
    )
  }
}

inputFieldItems.defaultProps = {
  items: [],
}

const InputFieldItems = handleOnClickOutside(inputFieldItems)
InputFieldItems.displayName = 'InputFieldItems'
export default InputFieldItems
